export enum BackgroundTypeEnum {
  GRADIENT = "gradient",
  IMAGE = "image",
  SOLID = "solid",
}
